import React from 'react';

const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

const isTorinoCenter = (item) => {
  const title = item?.shopping_center?.title?.toLowerCase() || '';
  const name = item?.shopping_center?.name?.toLowerCase() || '';
  return title.includes('torino') || name.includes('torino');
};

const getShoppingCenterDomain = (shoppingCenter) => {
  if (!shoppingCenter) {
    return null;
  }

  const centerName = (
    shoppingCenter.title ||
    shoppingCenter.name ||
    ''
  ).toLowerCase();

  if (centerName.includes('torino')) {
    return 'torinooutletvillage.com';
  }
  if (centerName.includes('roma')) {
    return 'romaoutletvillage.com';
  }
  if (centerName.includes('sicilia')) {
    return 'siciliaoutletvillage.com';
  }

  if (shoppingCenter.domain) {
    return shoppingCenter.domain;
  }
  if (shoppingCenter.website) {
    return shoppingCenter.website.replace(/^https?:\/\//, '');
  }

  return null;
};

const buildLandingUrl = (domain, lang, linkPath) => {
  if (!domain || !linkPath) {
    return null;
  }
  return `https://${domain}/${lang}/landing/${linkPath}`;
};

const linkField = (url) => {
  if (!url) {
    return '—';
  }
  return (
    <a
      href={url}
      target='_blank'
      rel='noreferrer'
      style={{ wordBreak: 'break-all', fontFamily: 'monospace', fontSize: 12 }}
    >
      {url}
    </a>
  );
};

const htmlContent = (html) => {
  if (!html) {
    return '—';
  }
  return (
    <div
      style={{ maxWidth: '100%', wordBreak: 'break-word' }}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

const getContentHtml = (item, langSuffix) => {
  const block = item?.content?.[langSuffix];
  return block?.html || null;
};

const buildLanguageFields = (t, item, lang) => {
  const suffix = lang.toLowerCase();
  const title = item[`title_${suffix}`] || (suffix === 'it' ? item.title : '');
  const linkPath =
    item[`link_${suffix}`] || (suffix === 'it' ? item.link_it : '');
  const domain = getShoppingCenterDomain(item.shopping_center);
  const publicUrl = buildLandingUrl(domain, suffix, linkPath);

  return [
    { text: `${t('Titolo')} ${lang}`, value: display(title) },
    {
      text: `${t('Link')} ${lang}`,
      value: display(linkPath),
    },
    {
      text: `${t('URL pubblico')} ${lang}`,
      value: linkField(publicUrl),
    },
    {
      text: `${t('Meta Title')} ${lang}`,
      value: display(item[`meta_title_${suffix}`]),
    },
    {
      text: `${t('Meta Description')} ${lang}`,
      value: display(item[`meta_description_${suffix}`]),
    },
    {
      text: `${t('Meta URL')} ${lang}`,
      value: display(item[`meta_url_${suffix}`]),
    },
    {
      text: `${t('Contenuto')} ${lang}`,
      value: htmlContent(getContentHtml(item, suffix)),
    },
  ];
};

const formatDate = (value) => {
  if (!value) {
    return '—';
  }
  return new Date(value).toLocaleDateString('it-IT');
};

export const getLandingPageViewSections = (t, item) => {
  if (!item?.id) {
    return [];
  }

  const sections = [
    {
      title: t('Informazioni Generali'),
      fields: [
        {
          text: t('Outlet Village'),
          value: display(item.shopping_center?.title),
        },
        {
          text: t('Data creazione'),
          value: formatDate(item.created_at),
        },
      ],
    },
    {
      title: `${t('Metadati')} (IT)`,
      fields: buildLanguageFields(t, item, 'IT'),
    },
    {
      title: `${t('Metadati')} (EN)`,
      fields: buildLanguageFields(t, item, 'EN'),
    },
  ];

  if (isTorinoCenter(item)) {
    sections.push({
      title: `${t('Metadati')} (FR)`,
      fields: buildLanguageFields(t, item, 'FR'),
    });
  }

  return sections;
};
